<template>
  <b-modal
    id="modal-perhitungan"
    ref="modalInboundConfirmationKompack"
    size="xl"
    centered
    hide-header
    hide-header-close
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    ok-title="Konfirmasi Inbound"
    body-class="!p-[32px]"
    content-class="!max-w-[1150px] !mx-auto"
    dialog-class="!max-w-[100%]"
  >
    <template>
      <div class="text-black text-[24px] font-[600] mb-[24px]">
        Perhitungan Barang
      </div>
      <b-table
        :fields="fieldProductConfirm"
        :items="mappedProducts"
        sticky-header="300px"
      >
        <template #cell(product_name)="row">
          <div
            v-if="!row.item.product_same_as_before"
            class="flex items-center gap-[12px]"
          >
            <b-img
              :src="
                row.item.image_path
                  ? row.item.image_path
                  : 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'
              "
              fluid
              class="object-cover object-center w-[50px] h-[50px] rounded-[16px]"
            />
            <div class="text-[#000000]">
              {{ row.item.product_name }}
              <div class="text-[#E31A1A] text-[12px]">
                SKU: {{ row.item.sku }}
              </div>
            </div>
          </div>
          <span v-else />
        </template>
        <template #cell(total_inbound_confirm)="row">
          <TotalInboundConfirmCell
            v-model="row.item.total_inbound_confirm"
            :requested-total-inbound="row.item.total_inbound"
            :disabled="isMutating"
            @input="handleInputTotalInboundConfirm(row.item, $event)"
          />
        </template>
        <template #cell(dimension)="row">
          <DimensionSettingCell
            v-if="isFirstVariantOfProduct(row.item)"
            :product="row.item"
            :disabled="isDimensionDisabled(row.item)"
            @input-dimension="handleInputDimensions(row.item, $event)"
          />
        </template>
      </b-table>
      <div class="flex justify-end gap-[12px]">
        <b-button
          variant="outline-primary"
          :disabled="isMutating"
          @click="hide"
        >
          Batalkan
        </b-button>
        <b-button
          variant="primary"
          class="!flex items-center justify-center gap-[8px]"
          :disabled="isMutating"
          @click="handleOk"
        >
          <b-spinner
            v-if="isMutating"
            variant="light"
            small
          />
          Konfirmasi Inbound
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { numberFormatter } from '@/libs/helpers'
import { fieldProductConfirm } from './config'
import DimensionSettingCell from './DimensionSettingCell.vue'
import TotalInboundConfirmCell from './TotalInboundConfirmCell.vue'

/**
 * ModalPerhitunganBarang component
 * @description This component is used to display the inbound verification setting
 * & build the payload for confirm inbound with dimension verification ability.
 */
export default {
  components: {
    DimensionSettingCell,
    TotalInboundConfirmCell,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fieldProductConfirm,
      renderCount: 0,
      isMutating: false,
    }
  },
  computed: {
    mappedProducts() {
      return this.products.reduce((acc, product, refIndex) => {
        if (product.is_variant === 1) {
          const variants = product.variant.map((variant, index) => ({
            ...product,
            ...variant,
            product_same_as_before: index > 0,
            ref_index: refIndex,
            ref_variant_index: index,
          }))
          return [...acc, ...variants]
        }
        return [...acc, {
          ...product,
          ref_index: refIndex,
          ref_variant_index: null,
        }]
      }, [])
    },
  },
  watch: {
    /**
     * Watch the products prop and update the local payload when it changes
     * @param {Array} newVal - The new value of the products prop
     * @returns {void}
     */
    products: {
      handler(newVal) {
        this.localPayload = {
          memo: 'Inbound dikonfirmasi sesuai QC',
          products: newVal?.map(product => ({
            inbound_detail_id: product.inbound_detail_id,
            product_id: product.product_id,
            total_inbound_confirm: 0,
            product_length: product.product_length,
            product_width: product.product_width,
            product_height: product.product_height,
            variant: product.variant?.map(variant => ({
              inbound_option_id: variant.inbound_option_id,
              variant_id: variant.variant_id,
              total_inbound_confirm: 0,
            })),
          })),
        }
      },
      deep: true,
    },
  },
  methods: {
    numberFormatter,
    /**
     * Check if the dimension is disabled.
     * Condition if confirmation being submitted or the dimension is updated by mitra before.
     */
    isDimensionDisabled(item) {
      return this.isMutating || item.is_updated_dimension_by_mitra === 1
    },
    async handleOk(e) {
      e.preventDefault()
      this.$emit('confirm-inbound', this.localPayload)
    },
    isFirstVariantOfProduct(item) {
      return item.ref_variant_index === 0 || item.ref_variant_index === null
    },
    handleInputTotalInboundConfirm(item, value) {
      if (item.ref_index === null || item.ref_index === undefined) {
        return
      }
      if (item.ref_variant_index === null || item.ref_variant_index === undefined) {
        this.localPayload.products[item.ref_index].total_inbound_confirm = value
        return
      }
      this.localPayload.products[item.ref_index].variant[item.ref_variant_index].total_inbound_confirm = value
    },
    handleInputDimensions(item, event) {
      if (item.ref_index === null || item.ref_index === undefined) {
        return
      }
      this.localPayload.products[item.ref_index][event.name] = event.value
    },
    /**
     * Hide the modal perhitungan barang
     * @public can be called by parent component to hide the modal
     * @returns {void}
     */
    hide() {
      this.$refs.modalInboundConfirmationKompack.hide()
    },
  },
}
</script>
